import { TestCloudFunction } from "../../../../src/components/TestCloudFunctions";
import * as React from 'react';
export default {
  TestCloudFunction,
  React
};